import { render, staticRenderFns } from "./nh-menu.vue?vue&type=template&id=edf3b78c&scoped=true&"
import script from "./nh-menu.vue?vue&type=script&lang=js&"
export * from "./nh-menu.vue?vue&type=script&lang=js&"
import style0 from "./nh-menu.vue?vue&type=style&index=0&id=edf3b78c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf3b78c",
  null
  
)

export default component.exports